import React, { useEffect } from "react";
import { Route, Router, Switch } from "react-router-dom";
import { ApmRoute } from "@elastic/apm-rum-react";
import history from "./config/history";
import PublicRoute from "./components/common/components/publicRoute";
import PrivateRoute from "./components/common/components/PrivateRoute";
import ResetPassword from "./components/user/components/resetPassword";
import PageNotFound from "./components/common/components/PageNotFound";
import ExportLinkRoutingPage from "./components/common/components/ExportLinkRoutingPage";
import { ToastContainer } from "react-toastify";
import NotificationTest from "./components/common/components/NotificationTest";
import TestImageEditor from "./components/common/components/TestImageEditor";
import PrivacyPolicy from "./components/common/components/PrivacyPolicy";
import CapitalRequest from "./components/capitalRequest";
import { RequestorVerify } from "./components/capitalRequest/components/RequestorVerify";
import UnsavedChangesPrompt from "./components/unSavedChangesPrompt/UnSavedChangesPrompt";
import { userRoles } from "./config/userRoles";
import { OTTO_PAGES } from "./components/filterAssistant/core/ottoAccess";
import BuildingLease from "./components/buildingLease";
import MobilePrivacyPolicy from "./components/common/components/MobilePrivacyPolicy";
import ErrorBoundary from "./components/common/ErrorBoundary";
import FcaNoticePrompt from "./components/fcaNoticePrompt/FcaNoticePrompt";
import AppUpdateBanner from "./components/common/components/AppUpdateBanner";
import SessionHeartbeat from "./components/activeSessions/SessionHeartbeat";
import { ACTIVE_SESSIONS_FLAG } from "./components/activeSessions/constants";
import { isEnabled } from "./services/featureFlags";
const Project = React.lazy(() => import("./components/project"));
const LoginForm = React.lazy(() => import("./components/user/components/LoginForm"));
const Dashboard = React.lazy(() => import("./components/dashboard"));
const Region = React.lazy(() => import("./components/region"));
const Site = React.lazy(() => import("./components/site"));
const Building = React.lazy(() => import("./components/building"));
const Recommendations = React.lazy(() => import("./components/recommendations/index"));
const MobileRecommendations = React.lazy(() => import("./components/mobileRecommendation/index"));
const Floor = React.lazy(() => import("./components/floor"));
const BuildingType = React.lazy(() => import("./components/buildingtype"));
const Client = React.lazy(() => import("./components/client"));
const User = React.lazy(() => import("./components/users"));
const UserPermissions = React.lazy(() => import("./components/userPermissions"));
const Templates = React.lazy(() => import("./components/template"));
const Helpers = React.lazy(() => import("./components/helper"));
const Logs = React.lazy(() => import("./components/log"));
const Consultancy = React.lazy(() => import("./components/consultancy"));
const ForgotPassword = React.lazy(() => import("./components/user/components/forgotPassword"));
const Initiatives = React.lazy(() => import("./components/initiatives"));
const Documents = React.lazy(() => import("./components/documents"));
const Reports = React.lazy(() => import("./components/reports"));
const MasterTrade = React.lazy(() => import("./components/master_trade"));
const MasterSystem = React.lazy(() => import("./components/master_system"));
const MasterSubSystem = React.lazy(() => import("./components/master_subsystem"));
const SpecialReport = React.lazy(() => import("./components/special_report"));
const ReportParagraph = React.lazy(() => import("./components/report_paragraph"));
const ChildParagraph = React.lazy(() => import("./components/child_paragraph"));
const ChartsAndGraphs = React.lazy(() => import("./components/charts_and_graphs"));
const SystemTables = React.lazy(() => import("./components/system_tables"));
const NarrativeTemplate = React.lazy(() => import("./components/narrativeTemplate"));
const TableTemplate = React.lazy(() => import("./components/tableTemplate"));
const ReportNoteTemplate = React.lazy(() => import("./components/reportNoteTemplate"));
const ReportTemplates = React.lazy(() => import("./components/reportTemplates"));
const ReportProperties = React.lazy(() => import("./components/reportProperties"));
const BuildingAddition = React.lazy(() => import("./components/buildingAddition"));
const Images = React.lazy(() => import("./components/images"));
const LandingPage = React.lazy(() => import("./components/landingPage"));
const ManageLandingPage = React.lazy(() => import("./components/manageLandingPage"));
const manageHeadings = React.lazy(() => import("./components/manageHeadings"));
const Assets = React.lazy(() => import("./components/assets"));
const AssetSettings = React.lazy(() => import("./components/assetSettings"));
const DocumentSettings = React.lazy(() => import("./components/documentSettings"));
const PropertyValues = React.lazy(() => import("./components/reportPropertyValues"));
const RecommendationTemplate = React.lazy(() => import("./components/recommendationTemplate"));
const Meters = React.lazy(() => import("./components/meterManagement"));
const EnergyManagement = React.lazy(() => import("./components/energyManagment"));
const Accounts = React.lazy(() => import("./components/accounts"));
const AssetManagement = React.lazy(() => import("./components/assetManagement"));
const AssetDashboard = React.lazy(() => import("./components/assetDashboard"));
const chartTemplates = React.lazy(() => import("./components/chartTemplates"));
const ComingSoon = React.lazy(() => import("./components/common/components/ComingSoon"));
const ChartProperties = React.lazy(() => import("./components/chartProperties"));
const Email = React.lazy(() => import("./components/email"));
const Notifications = React.lazy(() => import("./components/notification/index"));
const SmartCharts = React.lazy(() => import("./components/smartCharts/index"));
const SignInWithSSO = React.lazy(() => import("./components/user/components/SignInWithSSO"));
const AuthCallback = React.lazy(() => import("./components/user/components/AuthCallback"));
// const Escalation = React.lazy(() => import("./components/common/components/Escalation"));
const DynamicFieldSettings = React.lazy(() => import("./components/dynamicFieldSettings"));
const DynamicTables = React.lazy(() => import("./components/dynamicTables"));
const ClientDynamicTables = React.lazy(() => import("./components/clientDynamicTables"));
const Median = React.lazy(() => import("./components/medianManagement/index"));
const AssetSurveyProject = React.lazy(() => import("./components/assetSurveyProject"));
const AssetSurveyTemplate = React.lazy(() => import("./components/assetSurveyTemplate"));
const MobilerecommendationTemplate = React.lazy(() => import("./components/mobileRecommendationTemplates"));
const AssetSurveySettings = React.lazy(() => import("./components/assetSurveySettings"));
const SurveyProfileIndex = React.lazy(() => import("./components/surveyorProfiles"));
const LocalProjectSettingsTemplate = React.lazy(() => import("./components/projectSettingsTemplate"));
const MasterProjectSettingsTemplate = React.lazy(() => import("./components/masterProjectSettings"));
const KnowledgeAdmin = React.lazy(() => import("./components/knowledgeAdmin/KnowledgeAdmin"));
const GeneralTaskManager = React.lazy(() => import("./components/taskManager"));
const ActiveSessions = React.lazy(() => import("./components/activeSessions/ActiveSessions"));

/**
 * Flag gate for the active-sessions route (FCA-6979).
 *
 * Gating only the SideMenu entry hides the door but leaves it unlocked: a
 * super-admin who has the URL could load the page in an environment where the
 * feature was never turned on. The flag is read here, at render time, rather
 * than when this module is evaluated, because FME definitions can arrive after
 * bootstrap and a gate decided at import time would be stuck on whatever was
 * true then. A failed check renders `PageNotFound`, which is exactly what
 * `PrivateRoute` already does for a failed role check, so the two gates are
 * indistinguishable to whoever hits them.
 */
const FlaggedActiveSessions = props => (isEnabled(ACTIVE_SESSIONS_FLAG) ? <ActiveSessions {...props} /> : <PageNotFound />);
const AssetTemplateBuilder = React.lazy(() => import("./components/assetTemplateBuilder/AssetTemplateBuilder"));
const OttoPermissions = React.lazy(() => import("./components/ottoPermissions/OttoPermissions"));
const QaQc = React.lazy(() => import("./components/qaQc/QaQc"));
const ImageAnalysisPage = React.lazy(() => import("./components/imageAnalysis/ImageAnalysisPage"));

const App = () => {
    useEffect(() => {
        const tabsOpen = localStorage.getItem("tabsOpen");
        if (tabsOpen == null) {
            localStorage.setItem("tabsOpen", 1);
        } else {
            localStorage.setItem("tabsOpen", parseInt(tabsOpen) + parseInt(1));
        }

        // define decrement counter part
        window.onunload = function (e) {
            const newTabCount = localStorage.getItem("tabsOpen");
            if (newTabCount !== null) {
                localStorage.setItem("tabsOpen", newTabCount - 1);
            }
        };

        const handleResize = () => {
            try {
                const windowWidth = window.innerWidth;
                const sidebarElement = document.getElementById("sidebar");
                const mainElement = document.getElementById("main");

                if (windowWidth >= 991) {
                    sidebarElement.classList.remove("expandnavbar");
                    mainElement.classList.remove("expandnavbarr");
                } else {
                    sidebarElement.classList.add("expandnavbar");
                    mainElement.classList.add("expandnavbarr");
                }
            } catch (error) {
                console.error("An error occurred:", error);
            }
        };
        handleResize();
        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    return (
        <ErrorBoundary name="AppErrorBoundary">
            <AppUpdateBanner />
            <ToastContainer
                position="bottom-center"
                autoClose={4000}
                newestOnTop
                limit={3}
                closeOnClick
                pauseOnHover
                theme="colored"
            />
            <Router history={history}>
                <UnsavedChangesPrompt />
                <FcaNoticePrompt />
                {/* Mounted above the Switch so the presence timer survives navigation
                    instead of restarting on every route change. Renders nothing and
                    emits nothing unless the `active_sessions_page` flag is on and the
                    user is signed in. FCA-6979. */}
                <SessionHeartbeat />
                <Switch>

                    <PublicRoute exact path="/" component={LoginForm} />
                    <PublicRoute exact path="/login" component={LoginForm} />
                    <ApmRoute exact path="/reset_password/:token" component={ResetPassword} />
                    <PublicRoute exact path="/forgot_password" component={ForgotPassword} />
                    <PublicRoute exact path="/sso" component={SignInWithSSO} />
                    <PublicRoute exact path="/auth/callback" component={AuthCallback} />
                    <PrivateRoute path="/home" exact component={LandingPage} />
                    <PrivateRoute path="/dashboard" component={Dashboard} />

                    <PrivateRoute path="/embedded-dashboard" component={Dashboard} roles={[userRoles.SUPER_ADMIN]} />

                    <PrivateRoute path="/initiatives" exact component={Initiatives} />
                    <PrivateRoute path="/initiatives/:section" exact component={Initiatives} />
                    <PrivateRoute path="/initiatives/:section/:tab" exact component={Initiatives} />
                    <PrivateRoute path="/initiatives/:section/:id/:tab" exact component={Initiatives} />

                    <PrivateRoute path="/region" exact component={Region} />
                    <PrivateRoute path="/region/:section" exact component={Region} />
                    <PrivateRoute path="/region/:section/:id/" exact component={Region} />
                    <PrivateRoute path="/region/:section/:id/:tab" exact component={Region} />
                    <PrivateRoute path="/region/:section/:id/:tab/:settingType" exact component={Region} />
                    <PrivateRoute path="/region/:section/:id/:tab/:subTab" exact component={Region} />

                    <PrivateRoute path="/efci" exact component={Project} />
                    <PrivateRoute path="/efci/:section/:id/:tab" exact component={Project} />

                    <PrivateRoute path="/project" exact component={Project} />
                    <PrivateRoute path="/project/:section" exact component={Project} />
                    <PrivateRoute path="/project/:section/:id/" exact component={Project} />
                    <PrivateRoute path="/project/:section/:id/:tab" exact component={Project} />
                    <PrivateRoute path="/project/:section/:id/:tab/:settingType" exact component={Project} />
                    <PrivateRoute path="/project/:section/:id/:tab/:settingType/:subSection" exact component={Project} />
                    <PrivateRoute path="/project/:section/:id/:tab/:settingType/:subSection/:subId" exact component={Project} />
                    <PrivateRoute path="/project/:section/:id/:tab/:settingType/:subSection/:subId/:subTab" exact component={Project} />

                    <PrivateRoute path="/site" exact component={Site} />
                    <PrivateRoute path="/site/:section" exact component={Site} />
                    <PrivateRoute path="/site/:section/:id" exact component={Site} />
                    <PrivateRoute path="/site/:section/:id/:tab" exact component={Site} />
                    <PrivateRoute path="/site/:section/:id/:tab/:settingType" exact component={Site} />
                    <PrivateRoute path="/site/:section/:id/:tab/:subTab" exact component={Site} />

                    <PrivateRoute path="/building" exact component={Building} />
                    <PrivateRoute path="/building/:section" exact component={Building} />
                    <PrivateRoute path="/building/:section/:id" exact component={Building} />
                    <PrivateRoute path="/building/:section/:id/:tab" exact component={Building} />
                    <PrivateRoute path="/building/:section/:id/:tab/:settingType" exact component={Building} />
                    <PrivateRoute path="/building/:section/:id/:tab/:subTab" exact component={Building} />

                    <PrivateRoute path="/settings/buildingtype" exact component={BuildingType} />
                    <PrivateRoute path="/buildingtype/:section/:id/:tab" exact component={BuildingType} />

                    <PrivateRoute path="/recommendations" exact component={Recommendations} />
                    <PrivateRoute path="/recommendations/:section" exact component={Recommendations} />
                    <PrivateRoute path="/recommendations/:section/:id" exact component={Recommendations} />
                    <PrivateRoute path="/recommendations/:section/:id/:tab" exact component={Recommendations} />

                    <PrivateRoute path="/mobrecoms" exact component={MobileRecommendations} />
                    <PrivateRoute path="/mobrecoms/:section" exact component={MobileRecommendations} />
                    <PrivateRoute path="/mobrecoms/:section/:id" exact component={MobileRecommendations} />
                    <PrivateRoute path="/mobrecoms/:section/:id/:tab" exact component={MobileRecommendations} />
                    <PrivateRoute path="/mobrecoms/:section/:id/:tab/:mrId" exact component={MobileRecommendations} />
                    <PrivateRoute path="/project-template/:section/:subTab/:templateId" exact component={MobilerecommendationTemplate} />

                    <PrivateRoute path="/floor/:section" exact component={Floor} />
                    <PrivateRoute path="/floor/:section/:id" exact component={Floor} />
                    <PrivateRoute path="/floor/:section/:id/:tab" exact component={Floor} />

                    <PrivateRoute path="/buildingAddition/:section" exact component={BuildingAddition} />
                    <PrivateRoute path="/buildingAddition/:section/:id" exact component={BuildingAddition} />
                    <PrivateRoute path="/buildingAddition/:section/:id/:tab" exact component={BuildingAddition} />

                    <PrivateRoute path="/client" exact component={Client} />
                    <PrivateRoute path="/client/:section" exact component={Client} />
                    <PrivateRoute path="/client/:section/:id/" exact component={Client} />
                    <PrivateRoute path="/client/:section/:id/:tab" exact component={Client} />

                    <PrivateRoute path="/settings/user" exact component={User} />
                    <PrivateRoute path="/settings/userPermissions" exact component={UserPermissions} />
                    <PrivateRoute path="/settings/userPermissions/:section" exact component={UserPermissions} />
                    <PrivateRoute path="/settings/userPermissions/:section/:id" exact component={UserPermissions} />
                    <PrivateRoute path="/settings/templates" exact component={Templates} />
                    <PrivateRoute path="/settings/templates/:section" exact component={Templates} />
                    <PrivateRoute path="/settings/templates/:section/:id" exact component={Templates} />

                    <PrivateRoute path="/user/:section" exact component={User} />
                    <PrivateRoute path="/user/:section/:id" exact component={User} />
                    <PrivateRoute path="/user/:section/:id/:tab" exact component={User} />

                    <PrivateRoute path="/consultancy" exact component={Consultancy} />
                    <PrivateRoute path="/consultancy/:section" exact component={Consultancy} />
                    <PrivateRoute path="/consultancy/:section/:id/" exact component={Consultancy} />
                    <PrivateRoute path="/consultancy/:section/:id/:tab" exact component={Consultancy} />

                    <PrivateRoute path="/documents" exact component={Documents} />
                    <PrivateRoute path="/documents/:section" exact component={Documents} />
                    <PrivateRoute path="/documents/:section/:id" exact component={Documents} />
                    <PrivateRoute path="/documents/:section/:id/:tab" exact component={Documents} />

                    <PrivateRoute path="/reports" exact component={Reports} />
                    <PrivateRoute path="/reports/:section" exact component={Reports} />
                    <PrivateRoute path="/reports/:section/:id" exact component={Reports} />
                    <PrivateRoute path="/reports/:section/:id/:tab" exact component={Reports} />
                    <PrivateRoute path="/reports/:section/:id/:tab/:settingType" exact component={Reports} />
                    <PrivateRoute path="/reports/:section/:id/:tab/:settingType/:subSection" exact component={Reports} />
                    <PrivateRoute path="/reports/:section/:id/:tab/:settingType/:subSection/:subId" exact component={Reports} />
                    <PrivateRoute path="/reports/:section/:id/:tab/:settingType/:subSection/:subId/:subTab" exact component={Reports} />

                    <PrivateRoute path="/settings/reportProperties" exact component={ReportProperties} />
                    <PrivateRoute path="/settings/reportProperties/:section" exact component={ReportProperties} />
                    <PrivateRoute path="/settings/reportProperties/:section/:id" exact component={ReportProperties} />
                    <PrivateRoute path="/settings/reportProperties/:section/:id/:tab" exact component={ReportProperties} />

                    <PrivateRoute path="/settings/reportTemplates" exact component={ReportTemplates} />
                    <PrivateRoute path="/settings/reportTemplates/:section" exact component={ReportTemplates} />
                    <PrivateRoute path="/settings/reportTemplates/:section/:id" exact component={ReportTemplates} />

                    <PrivateRoute path="/images" exact component={Images} />
                    <PrivateRoute path="/images/:section" exact component={Images} />
                    <PrivateRoute path="/images/:section/:id" exact component={Images} />
                    <PrivateRoute path="/images/:section/:id/:tab" exact component={Images} />

                    <PrivateRoute path="/trade" exact component={MasterTrade} />
                    <PrivateRoute path="/trade/:section" exact component={MasterTrade} />
                    <PrivateRoute path="/trade/:section/:id" exact component={MasterTrade} />
                    <PrivateRoute path="/trade/:section/:id/:tab" exact component={MasterTrade} />

                    <PrivateRoute path="/system" exact component={MasterSystem} />
                    <PrivateRoute path="/system/:section" exact component={MasterSystem} />
                    <PrivateRoute path="/system/:section/:id" exact component={MasterSystem} />
                    <PrivateRoute path="/system/:section/:id/:tab" exact component={MasterSystem} />

                    <PrivateRoute path="/subsystem" exact component={MasterSubSystem} />
                    <PrivateRoute path="/subsystem/:section" exact component={MasterSubSystem} />
                    <PrivateRoute path="/subsystem/:section/:id" exact component={MasterSubSystem} />
                    <PrivateRoute path="/subsystem/:section/:id/:tab" exact component={MasterSubSystem} />

                    <PrivateRoute path="/specialreport" exact component={SpecialReport} />
                    <PrivateRoute path="/specialreport/:section" exact component={SpecialReport} />
                    <PrivateRoute path="/specialreport/:section/:id" exact component={SpecialReport} />
                    <PrivateRoute path="/specialreport/:section/:id/:tab" exact component={SpecialReport} />

                    <PrivateRoute path="/reportparagraph" exact component={ReportParagraph} />
                    <PrivateRoute path="/reportparagraph/:section" exact component={ReportParagraph} />
                    <PrivateRoute path="/reportparagraph/:section/:id" exact component={ReportParagraph} />
                    <PrivateRoute path="/reportparagraph/:section/:id/:tab" exact component={ReportParagraph} />

                    <PrivateRoute path="/childparagraph" exact component={ChildParagraph} />
                    <PrivateRoute path="/childparagraph/:section" exact component={ChildParagraph} />
                    <PrivateRoute path="/childparagraph/:section/:id" exact component={ChildParagraph} />
                    <PrivateRoute path="/childparagraph/:section/:id/:tab" exact component={ChildParagraph} />

                    <PrivateRoute path="/chartsandgraphs" exact component={ChartsAndGraphs} />
                    <PrivateRoute path="/chartsandgraphs/:section" exact component={ChartsAndGraphs} />
                    <PrivateRoute path="/chartsandgraphs/:section/:id" exact component={ChartsAndGraphs} />
                    <PrivateRoute path="/chartsandgraphs/:section/:id/:tab" exact component={ChartsAndGraphs} />

                    <PrivateRoute path="/systemtables" exact component={SystemTables} />
                    <PrivateRoute path="/systemtables/:section" exact component={SystemTables} />
                    <PrivateRoute path="/systemtables/:section/:id" exact component={SystemTables} />
                    <PrivateRoute path="/systemtables/:section/:id/:tab" exact component={SystemTables} />

                    <PrivateRoute path="/narrativetemplate" exact component={NarrativeTemplate} />
                    <PrivateRoute path="/narrativetemplate/:section" exact component={NarrativeTemplate} />
                    <PrivateRoute path="/narrativetemplate/:section/:id" exact component={NarrativeTemplate} />
                    <PrivateRoute path="/narrativetemplate/:section/:id/:tab" exact component={NarrativeTemplate} />

                    <PrivateRoute path="/tabletemplate" exact component={TableTemplate} />
                    <PrivateRoute path="/tabletemplate/:section" exact component={TableTemplate} />
                    <PrivateRoute path="/tabletemplate/:section/:id" exact component={TableTemplate} />
                    <PrivateRoute path="/tabletemplate/:section/:id/:tab" exact component={TableTemplate} />

                    <PrivateRoute path="/reportnotetemplate" exact component={ReportNoteTemplate} />
                    <PrivateRoute path="/reportnotetemplate/:section" exact component={ReportNoteTemplate} />
                    <PrivateRoute path="/reportnotetemplate/:section/:id" exact component={ReportNoteTemplate} />
                    <PrivateRoute path="/reportnotetemplate/:section/:id/:tab" exact component={ReportNoteTemplate} />

                    <PrivateRoute path="/energymanagement" exact component={EnergyManagement} />
                    <PrivateRoute path="/energymanagement/:section" exact component={EnergyManagement} />
                    <PrivateRoute path="/energymanagement/:section/:id/" exact component={EnergyManagement} />
                    <PrivateRoute path="/energymanagement/:section/:id/:tab" exact component={EnergyManagement} />
                    <PrivateRoute path="/energymanagement/:section/:id/:tab/:settingType" exact component={EnergyManagement} />
                    <PrivateRoute path="/energymanagement/:section/:id/:tab/:settingType/:subSection/:subId" exact component={EnergyManagement} />
                    <PrivateRoute
                        path="/energymanagement/:section/:id/:tab/:settingType/:subSection/:subId/:subTab"
                        exact
                        component={EnergyManagement}
                    />

                    <PrivateRoute path="/meter" exact component={Meters} />
                    <PrivateRoute path="/meter/:section" exact component={Meters} />
                    <PrivateRoute path="/meter/:section/:id" exact component={Meters} />
                    <PrivateRoute path="/meter/:section/:id/:tab" exact component={Meters} />

                    <PrivateRoute path="/median" exact component={Median} />
                    <PrivateRoute path="/median/:section" exact component={Median} />
                    <PrivateRoute path="/median/:section/:id" exact component={Median} />
                    <PrivateRoute path="/median/:section/:id/:tab" exact component={Median} />

                    <PrivateRoute path="/accounts" exact component={Accounts} />
                    <PrivateRoute path="/accounts/:section" exact component={Accounts} />
                    <PrivateRoute path="/accounts/:section/:id" exact component={Accounts} />
                    <PrivateRoute path="/accounts/:section/:id/:tab" exact component={Accounts} />

                    <PrivateRoute path="/settings/helpers" exact component={Helpers} />
                    <PrivateRoute path="/settings/logs" exact component={Logs} />
                    <PrivateRoute path="/settings/manageLandingPage" exact component={ManageLandingPage} />
                    <PrivateRoute path="/settings/manageLandingPage/:section" exact component={ManageLandingPage} />
                    <PrivateRoute path="/settings/manageLandingPage/:section/:id" exact component={ManageLandingPage} />

                    <PrivateRoute path="/settings/helpers" exact component={Helpers} />
                    <PrivateRoute path="/settings/logs" exact component={Logs} />
                    <PrivateRoute path="/settings/manageHeadings" exact component={manageHeadings} />
                    <PrivateRoute path="/settings/manageHeadings/:section" exact component={manageHeadings} />
                    <PrivateRoute path="/settings/manageHeadings/:section/:id" exact component={manageHeadings} />

                    <PrivateRoute path="/assetmanagement" exact component={AssetManagement} />
                    <PrivateRoute path="/assetmanagement/:section" exact component={AssetManagement} />
                    <PrivateRoute path="/assetmanagement/:section/:id" exact component={AssetManagement} />
                    <PrivateRoute path="/assetmanagement/:section/:id/:tab" exact component={AssetManagement} />
                    <PrivateRoute path="/assetmanagement/:section/:id/:tab/:settingType" exact component={AssetManagement} />
                    <PrivateRoute path="/assetdashboard" exact component={AssetDashboard} />

                    <PrivateRoute path="/assets" exact component={Assets} />
                    <PrivateRoute path="/assets/:section" exact component={Assets} />
                    <PrivateRoute path="/assets/:section/:id" exact component={Assets} />
                    <PrivateRoute path="/assets/:section/:id/:tab" exact component={Assets} />

                    <PrivateRoute path="/asset-settings/:settingType" exact component={AssetSettings} />
                    <PrivateRoute path="/asset-settings/:settingType/:section" exact component={AssetSettings} />
                    <PrivateRoute path="/asset-settings/:settingType/:section/:id" exact component={AssetSettings} />
                    <PrivateRoute path="/asset-settings/:settingType/:section/:id/:tab" exact component={AssetSettings} />

                    <PrivateRoute path="/document-settings/:settingType" exact component={DocumentSettings} />
                    <PrivateRoute path="/document-settings/:settingType/:section" exact component={DocumentSettings} />
                    <PrivateRoute path="/document-settings/:settingType/:section/:id" exact component={DocumentSettings} />
                    <PrivateRoute path="/document-settings/:settingType/:section/:id/:tab" exact component={DocumentSettings} />

                    <PrivateRoute path="/settings/reportpropertyvalues/:tab" exact component={PropertyValues} />
                    <PrivateRoute path="/settings/reportpropertyvalues/:tab/:section" exact component={PropertyValues} />
                    <PrivateRoute path="/settings/reportpropertyvalues/:tab/:section/:id" exact component={PropertyValues} />

                    <PrivateRoute path="/recommendationtemplate" exact component={RecommendationTemplate} />
                    <PrivateRoute path="/recommendationtemplate/:section" exact component={RecommendationTemplate} />
                    <PrivateRoute path="/recommendationtemplate/:section/:id" exact component={RecommendationTemplate} />
                    <PrivateRoute path="/recommendationtemplate/:section/:id/:tab" exact component={RecommendationTemplate} />

                    <PrivateRoute path="/chartTemplates" exact component={chartTemplates} />
                    <PrivateRoute path="/chartTemplates/:section" exact component={chartTemplates} />
                    <PrivateRoute path="/chartTemplates/:section/:id" exact component={chartTemplates} />
                    <PrivateRoute path="/chartTemplates/:section/:id/:tab" exact component={chartTemplates} />

                    <PrivateRoute path="/chartProperties" exact component={ChartProperties} />
                    <PrivateRoute path="/chartProperties/:section" exact component={ChartProperties} />
                    <PrivateRoute path="/chartProperties/:section/:id" exact component={ChartProperties} />
                    <PrivateRoute path="/chartProperties/:section/:id/:tab" exact component={ChartProperties} />

                    <PrivateRoute path="/settings/email" exact component={Email} />
                    <PrivateRoute path="/settings/email/:section" exact component={Email} />
                    <PrivateRoute path="/settings/email/:section/:id" exact component={Email} />

                    <PrivateRoute path="/settings/notifications" exact component={Notifications} />
                    <PrivateRoute path="/settings/notifications/:section" exact component={Notifications} />
                    <PrivateRoute path="/settings/notifications/:section/:id" exact component={Notifications} />

                    <PrivateRoute path="/smartcharts" exact component={SmartCharts} />
                    <PrivateRoute path="/smartcharts/:section" exact component={SmartCharts} />
                    <PrivateRoute path="/smartcharts/:section/:viewType" exact component={SmartCharts} />
                    <PrivateRoute path="/smartcharts/:section/:viewType/:id" exact component={SmartCharts} />

                    <ApmRoute path="/notificationTest" exact component={NotificationTest} />
                    <ApmRoute path="/TestImageEditor" exact component={TestImageEditor} />
                    <PrivateRoute path="/coming-soon" exact component={ComingSoon} />

                    <ApmRoute path="/export-routing-link/:id" exact component={ExportLinkRoutingPage} />

                    <ApmRoute path="/privacypolicy" exact component={PrivacyPolicy} />
                    <ApmRoute path="/mobile-privacy-policy" exact component={MobilePrivacyPolicy} />

                    <ApmRoute exact path="/capital-request/:code" component={CapitalRequest} />
                    <ApmRoute exact path="/capital-request/:code" component={CapitalRequest} />
                    <ApmRoute exact path="/capital-request/:code/:section" component={CapitalRequest} />
                    <ApmRoute exact path="/capital-request/:code/:section/:id" component={CapitalRequest} />
                    <ApmRoute exact path="/requestor/verify_email/:code/:token" component={RequestorVerify} />

                    <PrivateRoute exact path="/project-capital-request" component={CapitalRequest} />
                    <PrivateRoute exact path="/project-capital-request/:section" component={CapitalRequest} />
                    <PrivateRoute exact path="/project-capital-request/:section/:id" component={CapitalRequest} />

                    <PrivateRoute exact path="/dynamic-field-settings/:subTab" component={DynamicFieldSettings} />
                    <PrivateRoute exact path="/dynamic-field-settings/:subTab/:section" component={DynamicFieldSettings} />
                    <PrivateRoute exact path="/dynamic-field-settings/:subTab/:section/:id" component={DynamicFieldSettings} />

                    <PrivateRoute exact path="/dynamic-tables" component={DynamicTables} />
                    <PrivateRoute exact path="/dynamic-tables/:section" component={DynamicTables} />
                    <PrivateRoute exact path="/dynamic-tables/:section/:id" component={DynamicTables} />
                    <PrivateRoute exact path="/dynamic-tables/:section/:id/:tab" component={DynamicTables} />
                    <PrivateRoute exact path="/dynamic-tables/:section/:id/:tab/:subSection" component={DynamicTables} />
                    <PrivateRoute exact path="/dynamic-tables/:section/:id/:tab/:subSection/:childId" component={DynamicTables} />

                    <PrivateRoute exact path="/client-dynamic-tables" component={ClientDynamicTables} />
                    <PrivateRoute exact path="/client-dynamic-tables/:id" component={ClientDynamicTables} />
                    <PrivateRoute exact path="/client-dynamic-tables/:id/:subSection" component={ClientDynamicTables} />
                    <PrivateRoute exact path="/client-dynamic-tables/:id/:subSection/:childId" component={ClientDynamicTables} />

                    <PrivateRoute path="/asset-survey-project" exact component={AssetSurveyProject} />
                    <PrivateRoute path="/asset-survey-project/:section" exact component={AssetSurveyProject} />
                    <PrivateRoute path="/asset-survey-project/:section/:id" exact component={AssetSurveyProject} />
                    <PrivateRoute path="/asset-survey-project/:section/:subTab/:id" exact component={AssetSurveyProject} />
                    <PrivateRoute path="/asset-survey-project/:section/:subTab/:id/:subTabSection" exact component={AssetSurveyProject} />

                    <PrivateRoute path="/survey-template" exact component={AssetSurveyTemplate} />
                    <PrivateRoute path="/survey-template/:section" exact component={AssetSurveyTemplate} />
                    <PrivateRoute path="/survey-template/:section/:templateId" exact component={AssetSurveyTemplate} />

                    <PrivateRoute path="/project-template" exact component={MobilerecommendationTemplate} />
                    <PrivateRoute path="/project-template/:section" exact component={MobilerecommendationTemplate} />
                    <PrivateRoute path="/project-template/:section/:templateId" exact component={MobilerecommendationTemplate} />
                    <PrivateRoute path="/project-template/:section/:subTab/:templateId" exact component={MobilerecommendationTemplate} />

                    <PrivateRoute path="/global-project-template" exact component={MobilerecommendationTemplate} />
                    <PrivateRoute path="/global-project-template/:section" exact component={MobilerecommendationTemplate} />
                    <PrivateRoute path="/global-project-template/:section/:templateId" exact component={MobilerecommendationTemplate} />

                    <PrivateRoute path="/survey-settings" exact component={AssetSurveySettings} />

                    <PrivateRoute path="/surveyor-profiles" exact component={SurveyProfileIndex} />
                    <PrivateRoute path="/surveyor-profiles/:section/:id/:tab" exact component={SurveyProfileIndex} />
                    <PrivateRoute path="/surveyor-profiles/:id/:section/:surveyor_id/:tab/:subTab" exact component={SurveyProfileIndex} />

                    <PrivateRoute path="/buildingLease" exact component={BuildingLease} />
                    <PrivateRoute path="/buildingLease/:section" exact component={BuildingLease} />
                    <PrivateRoute path="/buildingLease/:section/:id" exact component={BuildingLease} />
                    <PrivateRoute path="/buildingLease/:section/:id/:tab" exact component={BuildingLease} />

                    <PrivateRoute path="/local-project-settings-template" exact component={LocalProjectSettingsTemplate} />
                    <PrivateRoute path="/local-project-settings-template/:section/:id/:settingType" exact component={LocalProjectSettingsTemplate} />
                    <PrivateRoute
                        path="/local-project-settings-template/:section/:id/:settingType/:subSection/:subId/:subTab"
                        exact
                        component={LocalProjectSettingsTemplate}
                    />

                    <PrivateRoute path="/master-project-settings-template" exact component={MasterProjectSettingsTemplate} />
                    <PrivateRoute
                        path="/master-project-settings-template/:section/:id/:settingType"
                        exact
                        component={MasterProjectSettingsTemplate}
                    />
                    <PrivateRoute
                        path="/master-project-settings-template/:section/:id/:settingType/:subSection/:subId/:subTab"
                        exact
                        component={MasterProjectSettingsTemplate}
                    />

                    <PrivateRoute path="/task-manager" exact component={GeneralTaskManager} />

                    {/* Admin active-sessions presence — SUPER_ADMIN only (FCA-6979), gated the
                        same way /settings/knowledge is, and additionally behind the
                        `active_sessions_page` FME flag (see FlaggedActiveSessions above). The
                        backend enforces the role again; this gate is the UX affordance, not the
                        security boundary. */}
                    <PrivateRoute path="/settings/active-sessions" exact component={FlaggedActiveSessions} roles={[userRoles.SUPER_ADMIN]} />

                    {/* Otto's AI Settings pages. Gated via PrivateRoute `ottoPage` rather than `roles`:
                        super_admins always pass, and any other user passes only if they were granted the
                        page on /settings/otto-permissions. Policy lives in filterAssistant/core/ottoAccess;
                        the page keys are the same vocabulary Otto's backend validates grants against. */}

                    {/* Platform knowledge-base authoring. */}
                    <PrivateRoute
                        path="/settings/knowledge"
                        exact
                        component={KnowledgeAdmin}
                        ottoPage={OTTO_PAGES.KNOWLEDGE_BASE}
                    />

                    {/* Asset model/manufacturer template curation. The path is deliberately NOT
                        /asset-templates: that route already exists for the unrelated survey
                        `dynamic_template` feature. */}
                    <PrivateRoute
                        path="/settings/asset-model-templates"
                        exact
                        component={AssetTemplateBuilder}
                        ottoPage={OTTO_PAGES.ASSET_MODEL_TEMPLATES}
                    />

                    {/* QA/QC anomaly analysis over a project's recommendations. Findings are written to
                        Otto's OWN issue table, never to Ruby's `recommendation_reviews` (the table behind a
                        recommendation's QA/QC tab) — see the 0014 migration in filter-ai. */}
                    <PrivateRoute path="/settings/qa-qc" exact component={QaQc} ottoPage={OTTO_PAGES.QA_QC} />

                    {/* Image Analyse: the Image Management grid in image-analysis mode. Readings are saved to
                        Otto's OWN table (otto_image_analysis), keyed by image_upload.id - never to the Ruby
                        image tables. */}
                    <PrivateRoute
                        path="/settings/image-analysis"
                        exact
                        component={ImageAnalysisPage}
                        ottoPage={OTTO_PAGES.IMAGE_ANALYSIS}
                    />

                    {/* Who may use Otto. Self-gating on purpose: a grant of this page is what lets a
                        non-super-admin delegate Otto access further. */}
                    <PrivateRoute
                        path="/settings/otto-permissions"
                        exact
                        component={OttoPermissions}
                        ottoPage={OTTO_PAGES.PERMISSIONS}
                    />

                    <ApmRoute component={PageNotFound} />
                </Switch>
            </Router>
        </ErrorBoundary>
    );
};

export default App;
